import { Meteor } from 'meteor/meteor';
import { Platform, Config, MenuController, NavController, AlertController, ModalController, LoadingController, ViewController } from 'ionic-angular';
import { AppVersion } from '@ionic-native/app-version';
import { Component, ViewChild } from '@angular/core';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Network } from '@ionic-native/network';
import { MeteorObservable } from 'meteor-rxjs';
import { Events } from 'ionic-angular/util/events';
import { Page } from 'ionic-angular/navigation/nav-util';
import { User } from 'api/models';
import { LoginComponent } from "../pages/auth/login/login.component";
import { ProjectHomePage } from '../pages/project-home/project-home';
import { AllCompaniesPage } from '../pages/all-companies/all-companies';
import * as permissions from '../services/permissions';
import { OpenNativeSettings } from '@ionic-native/open-native-settings';
// import { subscribeActiveCompany } from '../services/companyData';
import { CompanyService } from '../services/companyData';
import { CompanyPage } from '../pages/company/company';
import { Observable } from 'rxjs/Observable';
import { ISDEV } from "../services/config";
import { Storage } from '@ionic/storage';
import { AwsUtil } from "../providers/aws.service";
import { LogoutComponent } from "../pages/auth/logout.component";
import { HttpService } from '../services/httpService';
import { AuthenticationService } from '../services/congito';
import { Router } from '@angular/router';
import { NavigationEnd } from '@angular/router';  // Used to catch the page navigation events, for Google Analytics
import { filter } from 'rxjs/operators';  // Used to filter Router events, to only NavigationEnd
import { environment } from "../environments/environment"; // This allows us to switch the Google Analytics tracking code, based on the build type

declare var gtag; // Global variable for Google Tag manager



@Component({
  templateUrl: 'app.html'
})

export class Logit {
  @ViewChild('rootNav') rootNavCtrl: NavController;
  rootPage: any;
  viewer ? : User;

  public isDev = ISDEV;

  public loginPage = LoginComponent;
  public logoutPage = LogoutComponent;

  ready: boolean = false;
  isCordova: boolean;
  isIOS: boolean;
  isAndroid: boolean;
  loaded= false;
  connType: string = '';
  isOnline: boolean = false;



  async mainSubscription(){
    this.viewer = this.authenticationService.MeteorUser();
    const activeCompany = this.companyService.subscribeActiveCompany();
    if(this.viewer) {
      if(!this.loaded){
        this.loaded=true;
        const loader = this.loadingCtrl.create({
          content: "Please wait...",
          duration: 2000,
          enableBackdropDismiss: true,
        });
        loader.present();
      }
      // Change this if you want to change the default starting page
      // Helpful for developing without having to navigate by clicking around
      if(permissions.isSuperAdmin(this.viewer)) {
        this.rootPage = AllCompaniesPage;
      } else if(activeCompany && permissions.isCompanyAdmin(activeCompany, this.viewer)) {
        this.rootPage = CompanyPage;
      } else {
        this.rootPage = ProjectHomePage;
      }
      this.menuCtrl.enable(true);
    } else if(!(await this.storage.get("meteorUser"))){
      this.menuCtrl.close();
      this.menuCtrl.enable(false);
      this.rootPage = LoginComponent;
    } else {
      this.menuCtrl.close();
      this.menuCtrl.enable(false);
      this.rootPage = LoginComponent;
    }
  }



  constructor(
    platform: Platform,
    statusBar: StatusBar,
    splashScreen: SplashScreen,
    public config: Config,
    public plt: Platform,
    public menuCtrl: MenuController,
    public events: Events,
    public modalCtrl: ModalController,
    private appVersion: AppVersion,
    public loadingCtrl: LoadingController,
    public network: Network,
    public openNativeSettings: OpenNativeSettings,
    public alertCtrl: AlertController,
    private storage: Storage,
    public awsUtil: AwsUtil,
    public httpService: HttpService,
    public authenticationService: AuthenticationService,
    public companyService: CompanyService,
    router: Router
  ) {

    // Inject the Gooogle Analytics script into the <head>, using the environment-specific tracking code
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + environment.gtagTrackingCode;
    (document.head as any).prepend(script);

    // Catch page navigation end events, and generate Google Analytics tracking events from them
    // Send Router events through the filter, keeping only NavigationEnd
    const navEndEvent$ = router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    );
    // Subscribe to the output of the filter, and pass the result to Google Analytics, so that it reports page loads
    navEndEvent$.subscribe((e: NavigationEnd) => {
      gtag('config', environment.gtagTrackingCode, {'page_path':e.urlAfterRedirects});
    });

    storage.set('wbs', false);

    var offline = Observable.fromEvent(document, "offline");
    var online = Observable.fromEvent(document, "online");

    offline.subscribe(() => {
      let alert = this.alertCtrl.create({
        title: 'Your network is unavailable. Offline Mode has been activated',
        buttons: [
          {
            text: 'Check settings',
            handler: () => {
              this.openNativeSettings.open('wifi');
            }
          },
          {
            text: 'Continue & sync updates later',
            role: 'cancel'
          },

        ]
      });

      alert.present(alert);
    });

    online.subscribe(() => {
      let alert = this.alertCtrl.create({
        title: "Connection",
        message: "You are online!"
      });
      alert.present(alert);
    });


    this.events.subscribe('rootNavSetPages', (pages: (ViewController | { page: string | Page, params ? : any })[]) => {
      this.rootNavCtrl.setPages(pages);
      if(this.isDev == true) { console.log('cp10'); }
    });
    this.events.subscribe('rootNavPop', () => {
      this.rootNavCtrl.pop();
      if(this.isDev == true) { console.log('cp11'); }
    });
    this.events.subscribe('rootNavPush', (page: any, options: any) => {
      this.rootNavCtrl.push(page, options);
      if(this.isDev == true) { console.log('cp12'); }
    });

    /** App Versions */
    if(this.isDev == true) {
      this.appVersion.getAppName();
      this.appVersion.getPackageName();
      this.appVersion.getVersionCode();
      this.appVersion.getVersionNumber();
    }

    this.httpService.MeteorSubscribe('userData');
    this.companyService.subscribeActiveCompanyPromise()
    .then(()=>this.httpService.privateLoopAction(true))
    .then(res=>{
      MeteorObservable.autorun().subscribe(async () => {
        this.mainSubscription()
      });
    });

    setInterval(()=>{
      this.mainSubscription()
    }, 1000)

    this.network.onConnect().subscribe(() => {
      setTimeout(() => {
        disconnectSubscription.unsubscribe();
      })
    });

    /** watch network for a disconnect */
    let disconnectSubscription = this.network.onDisconnect().subscribe(() => {
      console.log('network was disconnected :-(');

      let alert = this.alertCtrl.create({
        cssClass: 'alert',
        title: 'Your network is unavailable. Offline Mode has been activated',
        buttons: [
          {
            text: 'Check settings',
            handler: () => {
              this.openNativeSettings.open('wifi');
            }
          },
          {
            text: 'Continue & sync updates later',
            role: 'cancel'
          },

        ]
      });
      alert.present();
      disconnectSubscription.unsubscribe();
    });



    /** stop disconnect watch */
    //disconnectSubscription.unsubscribe();


    /** watch network for a connection */
    let connectSubscription = this.network.onConnect().subscribe(() => {
      console.log('network connected!');
      setTimeout(() => {
        if(this.network.type === 'wifi') {
          console.log('we got a wifi connection, woohoo!');
        }
      }, 3000);
    });


    // stop connect watch
    connectSubscription.unsubscribe();


    this.isAndroid = plt.is('android');
    this.isCordova = plt.is('cordova');
    this.isIOS = plt.is('ios');

    let connHandler = (evt) => {
      //console.log('****** CONN CHANGED *******', evt.type);
      this.connType = network.type;
      if(evt.type == 'online') this.isOnline = true;
      else this.isOnline = false;
    }

    platform.ready().then(() => {
        // Okay, so the platform is ready and our plugins are available.
        // Here you can do any higher level native things you might need.

        this.ready = true;

        this.awsUtil.initAwsService();

        if(platform.is('cordova')) {

          this.connType = network.type;
          if(network.type != 'none') this.isOnline = true;

          this.network.onchange().subscribe(connHandler);
          this.network.onConnect().subscribe(connHandler);
          this.network.onDisconnect().subscribe(connHandler);

          this.plt.pause.subscribe(() => {
            //console.log('*******CORDOVA PAUSE*******');
          });

          this.plt.resume.subscribe(() => {
            console.log('******CORDOVA RESUME*******');
            setTimeout(() => {
              this.connType = this.network.type;
              console.log('******ON RESUME CONN TYPE******', this.connType);
            }, 3000);
          });

          statusBar.styleLightContent();
          splashScreen.hide();
        }

         this.listenToLoginEvents();

      })
      .catch(err => {
        //show alert
        let alert = this.alertCtrl.create({
          title: 'Your network is unavailable. Offline Mode has been activated',
          buttons: [
            {
              text: 'Check settings',
              handler: () => {
                this.openNativeSettings.open('wifi');
              }
            },
            {
              text: 'Continue & sync updates later',
              role: 'cancel'
            },

          ]
        });
        alert.present();

      });

  }
   listenToLoginEvents() {
        this.events.subscribe('user:login', () => {
           // this.enableMenu(true);
        });


        this.events.subscribe('user:logout', () => {
          //  this.enableMenu(false);
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts